module.exports = __webpack_public_path__ + "static/media/headlinestoday.2d9a504b.png";